import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NestedTreeControl } from '@angular/cdk/tree';
import { MatTreeNestedDataSource } from '@angular/material/tree';
import { CpqFormulaBuilderService } from '../cpq-formula-builder.service';
import { FormulaBuilderVisualizeStrings, SyntaxVisualizeResponse } from '../cpq-formula-builder.model';

@Component({
    selector: 'cpq-cpq-formula-builder-visualize-dialog',
    templateUrl: './cpq-formula-builder-visualize-dialog.component.html',
    styleUrls: ['./cpq-formula-builder-visualize-dialog.component.scss'],
    providers: [CpqFormulaBuilderService],
    standalone: false
})
export class CpqFormulaBuilderVisualizeDialogComponent implements OnInit {
  treeControl: NestedTreeControl<SyntaxVisualizeResponse>;
  dataSource: MatTreeNestedDataSource<SyntaxVisualizeResponse>;
  treeData: SyntaxVisualizeResponse[] = [];
  conditionFormulaWithNoSpaces: string;

  constructor(
    private service: CpqFormulaBuilderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CpqFormulaBuilderVisualizeDialogComponent>) { 
      this.treeControl = new  NestedTreeControl<SyntaxVisualizeResponse>(this.getChildren);
      this.dataSource = new MatTreeNestedDataSource();
    }

  ngOnInit(): void {
    if (this.data.conditionalFormula.trim()) {
      this.conditionFormulaWithNoSpaces = this.data.conditionalFormula.replace(/(\r\n|\n|\r)/gm, "");
      this.service.getVisualizeResponse(this.conditionFormulaWithNoSpaces.trim()).subscribe(response => {
        this.treeData.push(response);
        this.dataSource.data = this.treeData[0].children;
        this.treeControl.dataNodes = this.treeData[0].children;
        this.treeControl.expandAll();
      });
    }
  }

  getChildren(node: SyntaxVisualizeResponse) {
    return node.children;
  }

  public setNodeChildrenValueAndCheckHasChild(index: number, node: SyntaxVisualizeResponse): boolean {
    if (node.condition) {
      node.value = "IF";
      node.children[0].value = FormulaBuilderVisualizeStrings.Condition;
      node.children[1].value = FormulaBuilderVisualizeStrings.IfTrue;
      node.children[2].value = FormulaBuilderVisualizeStrings.IfFalse;
    }
    if (node.children) {
      if (node.children.length === 2 && !node.value) {
        if (node.name === "LIKE") {
          node.children[0].value = FormulaBuilderVisualizeStrings.String;
          node.children[1].value = FormulaBuilderVisualizeStrings.Pattern;
        } else {
          node.children[0].value = FormulaBuilderVisualizeStrings.TestedValue;
          node.children[1].value = FormulaBuilderVisualizeStrings.TestValue;
        }
      }
      if (node.children.length > 2 && !node.value && node.name === "IN") {
        node.children[0].value = FormulaBuilderVisualizeStrings.Pattern;
        for(let index = 1; index < node.children.length; index++) {
          node.children[index].value = `${FormulaBuilderVisualizeStrings.String} ${index.toString()}`;
        }
      } 
      if (node.children.length === 3 && !node.value && node.name === "INR") {
        node.children[0].value = FormulaBuilderVisualizeStrings.Option;
        node.children[1].value = FormulaBuilderVisualizeStrings.MinValue;
        node.children[2].value = FormulaBuilderVisualizeStrings.MaxValue;
      }
    }
    return node.children && node.children.length && !node.children.some(child => child.pos);
  }

  cancel() {
    this.dialogRef.close(null);
  }

}